const SESSION_TOKEN_KEY = 'signature_session_token';

export const storage = {
  getSessionToken(): string | null {
    return sessionStorage.getItem(SESSION_TOKEN_KEY);
  },

  setSessionToken(token: string): void {
    sessionStorage.setItem(SESSION_TOKEN_KEY, token);
  },

  clearSessionToken(): void {
    sessionStorage.removeItem(SESSION_TOKEN_KEY);
  },

  getAccessToken(): string | null {
    return this.getSessionToken();
  },
};
